import moment from "moment-timezone";

import { getCurrentLanguage } from "./locale";

export function formatMonth(month: number, culture?: string) {
    if (!culture) {
        culture = getCurrentLanguage();
    }
    return moment()
        .set("month", month - 1)
        .locale(culture)
        .format("MMMM");
}

export function formatPeriodBoundary(
    boundary: { month: number; year: number },
    culture?: string
): string {
    if (!culture) {
        culture = getCurrentLanguage();
    }
    const date = moment([boundary.year, boundary.month - 1, 1]).locale(culture);
    return date.format("MMMM Y");
}
